import { render, staticRenderFns } from "./emptyDataWithParams.vue?vue&type=template&id=145e98ca"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports